import { render, staticRenderFns } from "./sideInfoTitleBtnarea.vue?vue&type=template&id=656319a0&scoped=true&"
import script from "./sideInfoTitleBtnarea.vue?vue&type=script&lang=js&"
export * from "./sideInfoTitleBtnarea.vue?vue&type=script&lang=js&"
import style0 from "./sideInfoTitleBtnarea.vue?vue&type=style&index=0&id=656319a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656319a0",
  null
  
)

export default component.exports